// extracted by mini-css-extract-plugin
module.exports = {"mobileWidth":"980px","desktopWidth":"1920px","root":"tip_root__27PL1","tooltip":"tip_tooltip__Ull-N","tooltipArrow":"tip_tooltipArrow__d_O62"};